<mat-card>
<div *ngIf="!(lgvUserSvc.IsPreLicensedAgent$ | async)" class="widget-header">Want to see what you can afford?</div>
    <div>
        <mat-tab-group animationDuration="0ms">
            <mat-tab label="Mortgage">
                <div class="tab-content">
                    <app-loan-mortgage-calculator></app-loan-mortgage-calculator>
                </div>
            </mat-tab>
            <mat-tab label="Refinance">
                <div class="tab-content">
                    <app-loanRefiCalculator></app-loanRefiCalculator>
                </div>
            </mat-tab>
            <mat-tab label="DTI">
                <div class="tab-content">
                    <app-debt-income-calculator></app-debt-income-calculator>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

</mat-card>